// exports HttpCode - an immutable object 'enum'
// usage: import { HttpCode } from '../../enums/HttpCode';
const httpCode = {
    BadRequest: 400,
    Unauthorized: 401,
    Conflict: 409,
    InternalServerError: 500
};
Object.freeze(httpCode);
export const HttpCode = httpCode;